import React from 'react';
import { FormattedMessage } from 'react-intl';
import FeedbackView from './components/FeedbackView';

export default {
  path: 'palaute',
  name: <FormattedMessage id="feedback_title" />,
  components: { content: FeedbackView }
};
